export default __webpack_public_path__ + "static/media/icon_1_0.73aae579.svg";